import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Swal from 'sweetalert2';
import { getAllAppointments, deleteAppointment } from '../api/auth/bookAppointmentService';

function Bookappoinmentdetail() {
    const [data, setData] = useState([]);
    // const [formData, setFormData] = useState({
    //     name: '',
    //     phone: '',
    //     email: '',
    //     subject: '',
    //     address: '',
    //     message: '',
    //     date: ''
    // });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await getAllAppointments();
            setData(response);
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire(
                'Error!',
                'There was a problem fetching appointments.',
                'error'
            );
        }
    };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({ ...formData, [name]: value });
    // };

    // const handleCreate = async (e) => {
    //     e.preventDefault();
    //     try {
    //         const response = await createAppointment(formData);
    //         setData([...data, response]);
    //         setFormData({
    //             name: '',
    //             phone: '',
    //             email: '',
    //             subject: '',
    //             address: '',
    //             message: '',
    //             date: ''
    //         });
    //         Swal.fire(
    //             'Success!',
    //             'Appointment created successfully.',
    //             'success'
    //         );
    //     } catch (error) {
    //         console.error('Error creating appointment:', error);
    //         Swal.fire(
    //             'Error!',
    //             'There was a problem creating the appointment.',
    //             'error'
    //         );
    //     }
    // };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this entry!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteAppointment(id);
                    setData(data.filter(item => item.id !== id));
                    Swal.fire(
                        'Deleted!',
                        'The appointment has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting appointment:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the appointment.',
                        'error'
                    );
                }
            }
        });
    };

    return (
        <div>
            <Sidebar />
            <div className="col-md-9 px-0" style={{ marginLeft: '210px' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h5 className="page-title">Book Appointment Detail</h5>
                        </div>
                    </div>
                    {/* <div className="row mt-3">
                        <div className="col-md-12">
                            <form onSubmit={handleCreate}>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            placeholder="Name"
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            placeholder="Phone"
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            placeholder="Email"
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleInputChange}
                                            placeholder="Subject"
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="address"
                                            value={formData.address}
                                            onChange={handleInputChange}
                                            placeholder="Address"
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="date"
                                            value={formData.date}
                                            onChange={handleInputChange}
                                            placeholder="Date"
                                        />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <textarea
                                            className="form-control"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleInputChange}
                                            placeholder="Message"
                                            rows="4"
                                        ></textarea>
                                    </div>
                                    <div className="col-md-12">
                                        <button type="submit" className="btn btn-primary">
                                            Create Appointment
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className="col-md-10 mt-3" style={{ marginLeft: '210px' }}>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Email</th>
                            <th scope="col">Subject</th>
                            <th scope="col">Address</th>
                            <th scope="col">Message</th>
                            <th scope="col">Date</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.name}</td>
                                <td>{item.phone}</td>
                                <td>{item.email}</td>
                                <td>{item.subject}</td>
                                <td>{item.address}</td>
                                <td>{item.message}</td>
                                <td>{item.date || 'N/A'}</td>
                                <td>
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => handleDelete(item.id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Bookappoinmentdetail;